import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingCount: 0,
  loadingKeys: {},
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoadingStart(state, action) {
      state.loadingCount += 1;
      const key = action.payload;
      if (key) {
        state.loadingKeys[key] = (state.loadingKeys[key] || 0) + 1;
      }
    },
    setLoadingEnd(state, action) {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      const key = action.payload;
      if (key && state.loadingKeys[key]) {
        state.loadingKeys[key] = Math.max(0, state.loadingKeys[key] - 1);
        if (state.loadingKeys[key] === 0) {
          delete state.loadingKeys[key];
        }
      }
    },
    resetLoading(state) {
      state.loadingCount = 0;
      state.loadingKeys = {};
    },
  },
});

export const { setLoadingStart, setLoadingEnd, resetLoading } = uiSlice.actions;

export const selectIsLoading = (state) => state.ui.loadingCount > 0;

export const selectIsKeyLoading = (key) => (state) => (key ? (state.ui.loadingKeys[key] || 0) > 0 : state.ui.loadingCount > 0);

export default uiSlice.reducer;
